(() => {
  // node_modules/ftdomdelegate/main.js
  function Delegate(root) {
    this.listenerMap = [{}, {}];
    if (root) {
      this.root(root);
    }
    this.handle = Delegate.prototype.handle.bind(this);
    this._removedListeners = [];
  }
  Delegate.prototype.root = function (root) {
    const listenerMap = this.listenerMap;
    let eventType;
    if (this.rootElement) {
      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, true);
        }
      }
      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, false);
        }
      }
    }
    if (!root || !root.addEventListener) {
      if (this.rootElement) {
        delete this.rootElement;
      }
      return this;
    }
    this.rootElement = root;
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, false);
      }
    }
    return this;
  };
  Delegate.prototype.captureForType = function (eventType) {
    return (
      ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
        eventType,
      ) !== -1
    );
  };
  Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;
    if (!eventType) {
      throw new TypeError("Invalid event type: " + eventType);
    }
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      useCapture = this.captureForType(eventType);
    }
    if (typeof handler !== "function") {
      throw new TypeError("Handler must be a type of Function");
    }
    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!listenerMap[eventType]) {
      if (root) {
        root.addEventListener(eventType, this.handle, useCapture);
      }
      listenerMap[eventType] = [];
    }
    if (!selector) {
      matcherParam = null;
      matcher = matchesRoot.bind(this);
    } else if (/^[a-z]+$/i.test(selector)) {
      matcherParam = selector;
      matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
      matcherParam = selector.slice(1);
      matcher = matchesId;
    } else {
      matcherParam = selector;
      matcher = Element.prototype.matches;
    }
    listenerMap[eventType].push({
      selector,
      handler,
      matcher,
      matcherParam,
    });
    return this;
  };
  Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      this.off(eventType, selector, handler, true);
      this.off(eventType, selector, handler, false);
      return this;
    }
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
      for (singleEventType in listenerMap) {
        if (listenerMap.hasOwnProperty(singleEventType)) {
          this.off(singleEventType, selector, handler);
        }
      }
      return this;
    }
    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
      return this;
    }
    for (i = listenerList.length - 1; i >= 0; i--) {
      listener = listenerList[i];
      if (
        (!selector || selector === listener.selector) &&
        (!handler || handler === listener.handler)
      ) {
        this._removedListeners.push(listener);
        listenerList.splice(i, 1);
      }
    }
    if (!listenerList.length) {
      delete listenerMap[eventType];
      if (this.rootElement) {
        this.rootElement.removeEventListener(
          eventType,
          this.handle,
          useCapture,
        );
      }
    }
    return this;
  };
  Delegate.prototype.handle = function (event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = "ftLabsDelegateIgnore";
    if (event[eventIgnore] === true) {
      return;
    }
    target = event.target;
    if (target.nodeType === 3) {
      target = target.parentNode;
    }
    if (target.correspondingUseElement) {
      target = target.correspondingUseElement;
    }
    root = this.rootElement;
    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
    switch (phase) {
      case 1:
        listenerList = this.listenerMap[1][type];
        break;
      case 2:
        if (this.listenerMap[0] && this.listenerMap[0][type]) {
          listenerList = listenerList.concat(this.listenerMap[0][type]);
        }
        if (this.listenerMap[1] && this.listenerMap[1][type]) {
          listenerList = listenerList.concat(this.listenerMap[1][type]);
        }
        break;
      case 3:
        listenerList = this.listenerMap[0][type];
        break;
    }
    let toFire = [];
    l = listenerList.length;
    while (target && l) {
      for (i = 0; i < l; i++) {
        listener = listenerList[i];
        if (!listener) {
          break;
        }
        if (
          target.tagName &&
          ["button", "input", "select", "textarea"].indexOf(
            target.tagName.toLowerCase(),
          ) > -1 &&
          target.hasAttribute("disabled")
        ) {
          toFire = [];
        } else if (
          listener.matcher.call(target, listener.matcherParam, target)
        ) {
          toFire.push([event, target, listener]);
        }
      }
      if (target === root) {
        break;
      }
      l = listenerList.length;
      target = target.parentElement || target.parentNode;
      if (target instanceof HTMLDocument) {
        break;
      }
    }
    let ret;
    for (i = 0; i < toFire.length; i++) {
      if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
        continue;
      }
      returned = this.fire.apply(this, toFire[i]);
      if (returned === false) {
        toFire[i][0][eventIgnore] = true;
        toFire[i][0].preventDefault();
        ret = false;
        break;
      }
    }
    return ret;
  };
  Delegate.prototype.fire = function (event, target, listener) {
    return listener.handler.call(target, event, target);
  };
  const main_delegate = Delegate;
  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
  }
  function matchesRoot(selector, element) {
    if (this.rootElement === window) {
      return (
        element === document ||
        element === document.documentElement ||
        element === window
      );
    }
    return this.rootElement === element;
  }
  function matchesId(id, element) {
    return id === element.id;
  }
  Delegate.prototype.destroy = function () {
    this.off();
    this.root();
  };

  function triggerEvent(element, name, data = {}) {
    element.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail: data,
      }),
    );
  }

  function throttle(callback, delay3 = 15) {
    let throttleTimeout = null,
      storedEvent = null;
    const throttledEventHandler = (event) => {
      storedEvent = event;
      const shouldHandleEvent = !throttleTimeout;
      if (shouldHandleEvent) {
        callback(storedEvent);
        storedEvent = null;
        throttleTimeout = setTimeout(() => {
          throttleTimeout = null;
          if (storedEvent) {
            throttledEventHandler(storedEvent);
          }
        }, delay3);
      }
    };
    return throttledEventHandler;
  }

  function getSiblings(element, filter, includeSelf = false) {
    let siblings = [];
    let currentElement = element;
    while ((currentElement = currentElement.previousElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }
    if (includeSelf) {
      siblings.push(element);
    }
    currentElement = element;
    while ((currentElement = currentElement.nextElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }
    return siblings;
  }

  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => {
          const parentSection = this.closest(".shopify-section");
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return (this._rootDelegate =
        this._rootDelegate || new main_delegate(document.documentElement));
    }
    get delegate() {
      return (this._delegate = this._delegate || new main_delegate(this));
    }
    untilVisible(
      intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 },
    ) {
      const onBecameVisible = () => {
        this.classList.add("became-visible");
        this.style.opacity = "1";
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      this.delegate.destroy();
      this.rootDelegate.destroy();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };

  var NativeVideo = class extends HTMLElement {
    constructor() {
      super();
      this.hasLoaded = false;
      if (this.autoPlay) {
        this.play();
      } else {
        this.addEventListener("click", this.play.bind(this), { once: true });
      }
    }
    get autoPlay() {
      return this.hasAttribute("autoplay");
    }
    play() {
      if (!this.hasLoaded) {
        this._replaceContent();
      }
      this.querySelector("video").play();
    }
    pause() {
      if (this.hasLoaded) {
        this.querySelector("video").pause();
      }
    }
    _replaceContent() {
      const node =
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        );
      this.innerHTML = "";
      this.appendChild(node);
      this.firstElementChild.addEventListener("play", () => {
        this.dispatchEvent(new CustomEvent("video:played", { bubbles: true }));
      });
      this.firstElementChild.addEventListener("pause", () => {
        this.dispatchEvent(new CustomEvent("video:paused", { bubbles: true }));
      });
      this.hasLoaded = true;
    }
  };
  window.customElements.define("native-video", NativeVideo);

  var template = `
    <style>
        :host {
        display: inline-block;
        contain: layout;
        position: relative;
        }

        :host([hidden]) {
        display: none;
        }

        s {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        pointer-events: none;
        z-index: 1;
        background-image:
            var(--scroll-shadow-top, radial-gradient(farthest-side at 50% 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-bottom, radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-left, radial-gradient(farthest-side at 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-right, radial-gradient(farthest-side at 100%, rgba(0,0,0,.2), rgba(0,0,0,0)));
        background-position: top, bottom, left, right;
        background-repeat: no-repeat;
        background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
        }
    </style>
    <slot></slot>
    <s></s>
    `;
  var Updater = class {
    constructor(targetElement) {
      this.scheduleUpdate = throttle(() =>
        this.update(targetElement, getComputedStyle(targetElement)),
      );
      this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this));
    }
    start(element) {
      if (this.element) {
        this.stop();
      }
      if (element) {
        element.addEventListener("scroll", this.scheduleUpdate);
        this.resizeObserver.observe(element);
        this.element = element;
      }
    }
    stop() {
      if (!this.element) {
        return;
      }
      this.element.removeEventListener("scroll", this.scheduleUpdate);
      this.resizeObserver.unobserve(this.element);
      this.element = null;
    }
    update(targetElement, style) {
      if (!this.element) {
        return;
      }
      const maxSize = style.getPropertyValue("--scroll-shadow-size")
        ? parseInt(style.getPropertyValue("--scroll-shadow-size"))
        : 0;
      const scroll = {
        top: Math.max(this.element.scrollTop, 0),
        bottom: Math.max(
          this.element.scrollHeight -
            this.element.offsetHeight -
            this.element.scrollTop,
          0,
        ),
        left: Math.max(this.element.scrollLeft, 0),
        right: Math.max(
          this.element.scrollWidth -
            this.element.offsetWidth -
            this.element.scrollLeft,
          0,
        ),
      };
      requestAnimationFrame(() => {
        for (const position of ["top", "bottom", "left", "right"]) {
          targetElement.style.setProperty(
            `--${position}`,
            `${scroll[position] > maxSize ? maxSize : scroll[position]}px`,
          );
        }
      });
    }
  };
  var ScrollShadow = class extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: "open" }).innerHTML = template;
      this.updater = new Updater(this.shadowRoot.lastElementChild);
    }
    connectedCallback() {
      this.shadowRoot
        .querySelector("slot")
        .addEventListener("slotchange", () => this.start());
      this.start();
    }
    disconnectedCallback() {
      this.updater.stop();
    }
    start() {
      this.updater.start(this.firstElementChild);
    }
  };
  if ("ResizeObserver" in window) {
    window.customElements.define("scroll-shadow", ScrollShadow);
  }

  class ProductMediaImages extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.initSwiper();
      this.addEventListener("swiperControl:select", (event) =>
        this.select(event.detail.index),
      );
    }

    select(idx) {
      this.swiper.slideToLoop(idx);
    }
    initSwiper() {
      const swiperEl = this.querySelector(".swiper");
      const _this = this;
      if (!swiperEl) return;
      const lastIdx = this.dataset.lastIdx;
      this.swiper = new Swiper(swiperEl, {
        observer: true,
        observeParents: true,
        fadeEffect: {
          crossFade: true,
        },
        touchStartPreventDefault: true,
        passiveListeners: false,
        slidesPerView: 1,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
        on: {
          init(swiperInstance) {
            const realIndex = swiperInstance.realIndex;
            triggerEvent(_this, "swiper:ready", {
              realIndex,
            });
          },
          slideChange(swiperInstance) {
            const realIndex = swiperInstance.realIndex;
            triggerEvent(_this, "swiper:slide-changed", {
              realIndex,
            });
          },
        },
        navigation: {
          nextEl: this.querySelector(".btn-next"),
          prevEl: this.querySelector(".btn-prev"),
        },
      });
      if (lastIdx) {
        this.swiper.slideToLoop(lastIdx);
      }
    }
  }
  if (!customElements.get("product-media-images")) {
    customElements.define("product-media-images", ProductMediaImages);
  }

  var ProductMediaControls = class extends CustomHTMLElement {
    async connectedCallback() {
      this.productMediaImages.addEventListener(
        "swiper:ready",
        this._onSlideChanged.bind(this, false),
      );
      this.productMediaImages.addEventListener(
        "swiper:slide-changed",
        this._onSlideChanged.bind(this, true),
      );
      this.delegate.on("click", '[data-action="select"]', (event, target) => {
        this.productMediaImages.select(target.dataset.idx);
      });
    }
    get productMediaImages() {
      return (this._productMediaImages =
        this._productMediaImages ||
        document.getElementById(this.getAttribute("controls")));
    }
    async _onSlideChanged(animate = true, event) {
      const realIndex = event.detail.realIndex || 0;
      const activeItem = this.querySelector(
        `.product__thumbnail-item[data-idx="${realIndex}"]`,
      );
      activeItem.setAttribute("aria-current", "true");
      getSiblings(activeItem).forEach((sibling) =>
        sibling.removeAttribute("aria-current"),
      );
      requestAnimationFrame(() => {
        if (activeItem.offsetParent && activeItem.offsetParent !== this) {
          const windowHalfHeight = activeItem.offsetParent.clientHeight / 2,
            windowHalfWidth = activeItem.offsetParent.clientWidth / 2;
          activeItem.offsetParent.scrollTo({
            behavior: animate ? "smooth" : "auto",
            top:
              activeItem.offsetTop -
              windowHalfHeight +
              activeItem.clientHeight / 2,
            left:
              activeItem.offsetLeft -
              windowHalfWidth +
              activeItem.clientWidth / 2,
          });
        }
      });
    }
  };
  window.customElements.define("product-media-controls", ProductMediaControls);

  class VariantSelect extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.baseUrl = this.dataset.url;
      this.saveText = "Save";
      this.variants = [];
      this.currentVariant = null;
      this.optionGroups = [];
      this.qtyInput = null;
      this.minusBtn = null;
      this.plusBtn = null;

      const btnId = this.getAttribute("aria-controls");
      this.externalButton = document.getElementById(btnId);
      this.checkoutButton = document.getElementById(
        `ProductCheckoutButton-${this.sectionId}`,
      );
      this.errorMessageWrapper = this.querySelector(
        ".variants-form__error-message-wrapper",
      );
      this.sectionRoot = document;

      this.priceContainer = document.querySelector(
        `.product-price-${this.sectionId}`,
      );
      if (this.priceContainer) {
        const saveLabel = this.priceContainer.querySelector(".save-label");
        if (saveLabel) {
          this.saveText = saveLabel.innerText
            .replace(/[0-9.,$€£¥]/g, "")
            .trim();
        }
      }

      this.rows = [];
      this.isTablePicker = false;
      this.onOptionChange = this.onOptionChange.bind(this);
      this.updateQuantity = this.updateQuantity.bind(this);
      this.updateTableQuantity = this.updateTableQuantity.bind(this);
      this.addToCart = this.addToCart.bind(this);
      this.handleCheckout = this.handleCheckout.bind(this);
      this.handleErrorMessage = this.handleErrorMessage.bind(this);
      this.updateTotalPrice = this.updateTotalPrice.bind(this);
      this.syncSelectedVariantState = this.syncSelectedVariantState.bind(this);
      this.syncSellableRows = this.syncSellableRows.bind(this);
      this.isVariantSellable = this.isVariantSellable.bind(this);
      this.getSelectedItems = this.getSelectedItems.bind(this);
      this.onAddonCartUpdate = this.onAddonCartUpdate.bind(this);

      this.abortController = null;
      this.addonLocked = false;
      this.cartUpdateUnsubscribers = [];
    }

    connectedCallback() {
      this.sectionRoot = this.closest(".shopify-section") || document;
      this.isTablePicker = this.dataset.pickerType !== "option_picker";
      this.initCartAddonLock();

      if (this.externalButton) {
        this.externalButton.addEventListener("click", this.addToCart);
      }

      if (this.checkoutButton) {
        this.checkoutButton.addEventListener("click", this.handleCheckout);
      }

      if (this.isTablePicker) {
        this.initTablePicker();
      } else {
        this.initOptionPicker();
      }
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
      if (this.externalButton)
        this.externalButton.removeEventListener("click", this.addToCart);
      if (this.checkoutButton)
        this.checkoutButton.removeEventListener("click", this.handleCheckout);
      if (this.cartUpdateUnsubscribers?.length) {
        this.cartUpdateUnsubscribers.forEach((unsubscribe) => {
          if (typeof unsubscribe === "function") unsubscribe();
        });
        this.cartUpdateUnsubscribers = [];
      }
    }

    isCartAddonProduct() {
      const addon = window.theme?.settings?.cartAddon;
      if (!addon?.enabled) return false;
      if (this.dataset.cartAddon === "true") return true;
      return Boolean(
        addon.productId &&
        String(this.dataset.productId) === String(addon.productId),
      );
    }

    initCartAddonLock() {
      if (!this.isCartAddonProduct()) return;

      this.addonLocked = this.dataset.cartAddonInCart === "true";
      if (this.addonLocked) this.syncAddonButtonState(true);
      this.syncAddonLockFromCart();

      if (
        typeof subscribe === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        this.cartUpdateUnsubscribers = [
          subscribe(PUB_SUB_EVENTS.cartUpdate, this.onAddonCartUpdate),
          subscribe(PUB_SUB_EVENTS.cartAdd, this.onAddonCartUpdate),
          subscribe(PUB_SUB_EVENTS.cartRemove, this.onAddonCartUpdate),
        ];
      }
    }

    syncAddonLockFromCart() {
      const cartUrl = (window.Shopify?.routes?.root || "/") + "cart.js";
      fetch(cartUrl)
        .then((response) => response.json())
        .then((cart) => {
          const inCart = this.addonItemInCartData(cart);
          if (inCart !== null) this.syncAddonButtonState(inCart);
        })
        .catch(() => {});
    }

    addonItemInCartData(cartData) {
      const addon = window.theme?.settings?.cartAddon;
      if (!addon?.enabled || !cartData) return null;

      const matchItem = (item) =>
        (addon.productId &&
          String(item.product_id) === String(addon.productId)) ||
        (addon.variantId &&
          String(item.variant_id || item.id) === String(addon.variantId));

      const isFullCart = typeof cartData.item_count === "number";

      if (Array.isArray(cartData.items)) {
        const found = cartData.items.some(matchItem);
        if (found) return true;
        if (isFullCart) return false;
        return null;
      }

      if (cartData.product_id || cartData.variant_id || cartData.title) {
        return matchItem({
          product_id: cartData.product_id,
          variant_id: cartData.variant_id || cartData.id,
          id: cartData.id,
        });
      }

      return null;
    }

    onAddonCartUpdate(event) {
      const inCart = this.addonItemInCartData(event?.cartData);
      if (inCart === null) return;
      this.addonLocked = Boolean(inCart);
      if (this.addonLocked) {
        this.syncAddonButtonState(true);
      } else {
        this.syncPickerState();
      }
    }

    syncAddonButtonState(inCart) {
      this.addonLocked = Boolean(inCart);
      const alreadyText =
        window.variantStrings?.alreadyInCart || "Already in cart";
      const addText = window.variantStrings?.addToCart || "Add To Cart";

      if (this.externalButton) {
        this.externalButton.classList.remove("loading");
        this.externalButton.disabled = this.addonLocked;
        this.externalButton.dataset.cartAddonLocked = this.addonLocked
          ? "true"
          : "false";
        if (this.addonLocked) {
          this.externalButton.setAttribute("aria-disabled", "true");
        } else {
          this.externalButton.removeAttribute("aria-disabled");
        }
        const span = this.externalButton.querySelector("span");
        if (span) span.textContent = this.addonLocked ? alreadyText : addText;
      }

      if (this.checkoutButton) {
        this.checkoutButton.classList.remove("loading");
        this.checkoutButton.disabled = this.addonLocked;
        this.checkoutButton.dataset.cartAddonLocked = this.addonLocked
          ? "true"
          : "false";
        if (this.addonLocked) {
          this.checkoutButton.setAttribute("aria-disabled", "true");
        } else {
          this.checkoutButton.removeAttribute("aria-disabled");
        }
      }
    }

    initTablePicker() {
      this.rows = this.querySelectorAll(".variant-row");
      this.syncSellableRows();

      this.rows.forEach((row) => {
        const input = row.querySelector(".qty-input");
        const minus = row.querySelector(".minus");
        const plus = row.querySelector(".plus");

        if (minus) {
          minus.addEventListener("click", (event) => {
            event.stopPropagation();
            this.updateTableQuantity(row, input, -1);
          });
        }
        if (plus) {
          plus.addEventListener("click", (event) => {
            event.stopPropagation();
            this.updateTableQuantity(row, input, 1);
          });
        }
        if (input) {
          input.addEventListener("change", () =>
            this.updateTableQuantity(row, input, 0),
          );
          input.addEventListener("click", (event) => event.stopPropagation());
        }
      });

      this.updateTotalPrice();
    }

    bindProductQuantity() {
      const root = this.closest(".shopify-section") || document;
      this.qtyInput = root.querySelector(".product-qty .qty-input");
      this.minusBtn = root.querySelector(".product-qty .minus");
      this.plusBtn = root.querySelector(".product-qty .plus");

      if (this.minusBtn && !this.minusBtn.dataset.qtyBound) {
        this.minusBtn.dataset.qtyBound = "true";
        this.minusBtn.addEventListener("click", (event) => {
          event.preventDefault();
          this.updateQuantity(-1);
        });
      }
      if (this.plusBtn && !this.plusBtn.dataset.qtyBound) {
        this.plusBtn.dataset.qtyBound = "true";
        this.plusBtn.addEventListener("click", (event) => {
          event.preventDefault();
          this.updateQuantity(1);
        });
      }
      if (this.qtyInput && !this.qtyInput.dataset.qtyBound) {
        this.qtyInput.dataset.qtyBound = "true";
        this.qtyInput.addEventListener("change", () => this.updateQuantity(0));
      }
    }

    initOptionPicker() {
      this.optionGroups = Array.from(
        this.querySelectorAll(".product-option-group"),
      );
      this.variants = this.parseVariants();
      this.currentVariant =
        this.variants.find(
          (variant) =>
            String(variant.id) === String(this.dataset.selectedVariantId),
        ) ||
        this.variants[0] ||
        null;

      this.addEventListener("change", (event) => {
        if (
          event.target.matches('.product-option-values input[type="radio"]')
        ) {
          this.onOptionChange(event.target);
        }
      });

      this.bindProductQuantity();
      setTimeout(() => {
        this.bindProductQuantity();
        this.updateTotalPrice();
        this.syncSelectedVariantState();
      }, 0);

      this.selectVariant(this.currentVariant, {
        updateUrl: false,
        updateMedia: false,
      });
    }

    syncPickerState() {
      if (this.isTablePicker) {
        this.syncSellableRows();
      } else {
        this.syncSelectedVariantState();
      }
    }

    isRowSellable(row) {
      if (!row) return false;
      const canSell = String(row.dataset.canSell || "").toLowerCase();
      if (canSell === "true") return true;
      if (canSell === "false") return false;
      return !row.hasAttribute("aria-disabled");
    }

    getTablePolicyState() {
      let hasContinueSelling = false;
      let hasInStock = false;
      let hasOutOfStock = false;

      this.rows.forEach((row) => {
        const input = row.querySelector(".qty-input");
        const qty = input ? parseInt(input.value, 10) || 0 : 0;
        if (qty <= 0) return;

        if (row.dataset.policyState === "continue_selling") {
          hasContinueSelling = true;
        } else if (row.dataset.policyState === "in_stock") {
          hasInStock = true;
        } else {
          hasOutOfStock = true;
        }
      });

      if (hasContinueSelling) return "continue_selling";
      if (hasInStock) return "in_stock";
      if (hasOutOfStock) return "out_of_stock";
      return null;
    }

    syncSellableRows() {
      let hasSellableRow = false;
      const addToCartText = window.variantStrings?.addToCart || "Add To Cart";

      this.rows.forEach((row) => {
        const input = row.querySelector(".qty-input");
        const minus = row.querySelector(".minus");
        const plus = row.querySelector(".plus");
        const soldOutText = row.querySelector(".variant-sold-out-text");
        const sellable = this.isRowSellable(row);

        if (sellable) {
          hasSellableRow = true;
          row.removeAttribute("aria-disabled");
          if (input) input.disabled = false;
          if (minus) minus.disabled = false;
          if (plus) plus.disabled = false;
          if (soldOutText) soldOutText.style.display = "none";
        } else {
          row.setAttribute("aria-disabled", "true");
          if (input) {
            input.value = 0;
            input.disabled = true;
          }
          if (minus) minus.disabled = true;
          if (plus) plus.disabled = true;
          if (soldOutText) soldOutText.style.display = "";
        }
      });

      if (hasSellableRow) {
        if (this.addonLocked) {
          this.syncAddonButtonState(true);
        } else {
          if (this.externalButton) {
            this.externalButton.disabled = false;
            this.externalButton.removeAttribute("aria-disabled");
            const span = this.externalButton.querySelector("span");
            if (span && /sold out|unavailable/i.test(span.innerText))
              span.innerText = addToCartText;
          }
          if (this.checkoutButton) {
            this.checkoutButton.disabled = false;
            this.checkoutButton.removeAttribute("aria-disabled");
          }
        }
      }

      this.applyPolicyState(this.getTablePolicyState());
    }

    getTableSelectedItems() {
      const items = [];

      this.rows.forEach((row) => {
        const input = row.querySelector(".qty-input");
        if (!input || input.disabled) return;
        if (!this.isRowSellable(row)) return;

        const qty = parseInt(input.value, 10);
        const variantId = row.dataset.variantId;

        if (qty > 0 && variantId) {
          items.push({ id: parseInt(variantId, 10), quantity: qty });
        }
      });

      if (this.isCartAddonProduct() && items.length > 0) {
        return [{ id: items[0].id, quantity: 1 }];
      }

      return items;
    }

    updateTableQuantity(row, input, change) {
      const currentVal = parseInt(input.value, 10) || 0;
      const minQty = parseInt(this.dataset.minQty, 10) || 1;

      if (change < 0) {
        let totalQty = 0;
        this.rows.forEach((currentRow) => {
          const currentInput = currentRow.querySelector(".qty-input");
          totalQty += parseInt(currentInput.value, 10) || 0;
        });
        if (totalQty <= minQty && currentVal > 0) return;
      }

      let val = currentVal + change;
      if (minQty > 1 && val > 0 && val < minQty) {
        val = change > 0 ? minQty : 0;
      }

      if (isNaN(val) || val < 0) val = 0;
      if (this.isCartAddonProduct() && val > 1) val = 1;

      if (change === 0 && val === 0) {
        let otherTotalQty = 0;
        this.rows.forEach((currentRow) => {
          if (currentRow !== row) {
            const currentInput = currentRow.querySelector(".qty-input");
            otherTotalQty += parseInt(currentInput.value, 10) || 0;
          }
        });
        if (otherTotalQty === 0) val = minQty;
      }

      input.value = val;
      this.updateTotalPrice();
      this.applyPolicyState(this.getTablePolicyState());
    }

    parseVariants() {
      const script = this.querySelector("[data-product-variants]");
      if (!script) return [];
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return [];
      }
    }

    optionKey(index) {
      return `option${index + 1}`;
    }

    getSelectedOptions() {
      return this.optionGroups.map((group) => {
        const checked = group.querySelector("input:checked");
        return checked ? checked.value : null;
      });
    }

    getVariantOptionValue(variant, index) {
      if (Array.isArray(variant.options) && variant.options[index] != null) {
        return String(variant.options[index]);
      }
      const value = variant[this.optionKey(index)];
      return value == null ? "" : String(value);
    }

    findExactVariant(options) {
      return this.variants.find((variant) => {
        return options.every((value, index) => {
          if (!value) return true;
          return this.getVariantOptionValue(variant, index) === String(value);
        });
      });
    }

    getSelectedOptionValueIds() {
      return this.optionGroups
        .map(
          (group) =>
            group.querySelector("input:checked")?.dataset.optionValueId,
        )
        .filter(Boolean);
    }

    findVariantByOptionValueIds(optionValueIds) {
      return this.variants.find((variant) => {
        if (
          !Array.isArray(variant.optionValueIds) ||
          !variant.optionValueIds.length
        )
          return false;
        return optionValueIds.every(
          (id, index) =>
            String(variant.optionValueIds[index] || "") === String(id),
        );
      });
    }

    onOptionChange(input) {
      const selectedOptions = this.getSelectedOptions();
      const variant = this.findExactVariant(selectedOptions);

      if (variant) {
        this.selectVariant(variant);
      } else {
        this.currentVariant = null;
        this.updateOptionAvailability();
        this.updateTotalPrice();
        this.syncSelectedVariantState();
      }

      const optionValueIds = this.getSelectedOptionValueIds();
      if (optionValueIds.length) {
        this.renderOptionSelection(input, optionValueIds, selectedOptions);
      }
    }

    restoreSelectedOptions(values) {
      this.optionGroups.forEach((group, index) => {
        const value = values?.[index];
        if (value == null) return;
        const inputs = Array.from(group.querySelectorAll("input"));
        if (!inputs.some((input) => String(input.value) === String(value)))
          return;
        inputs.forEach((input) => {
          input.checked = String(input.value) === String(value);
        });
      });
    }

    renderOptionSelection(input, optionValueIds, selectedOptions) {
      const productUrl = input.dataset.productUrl || this.dataset.url;
      if (!productUrl || !this.sectionId) return;

      const params = new URLSearchParams({
        section_id: this.sectionId,
        option_values: optionValueIds.join(","),
      });

      this.abortController?.abort();
      this.abortController = new AbortController();

      fetch(`${productUrl}?${params.toString()}`, {
        signal: this.abortController.signal,
      })
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          const source =
            html.querySelector(`#variant-select-${this.sectionId}`) ||
            html.querySelector("variant-select");
          if (!source) return;

          const sourceOptions = source.querySelector(".product-option-list");
          const destOptions = this.querySelector(".product-option-list");
          if (sourceOptions && destOptions)
            destOptions.innerHTML = sourceOptions.innerHTML;
          this.optionGroups = Array.from(
            this.querySelectorAll(".product-option-group"),
          );

          const sourceJson = source.querySelector("[data-product-variants]");
          const destJson = this.querySelector("[data-product-variants]");
          if (sourceJson && destJson)
            destJson.textContent = sourceJson.textContent;
          this.variants = this.parseVariants();
          if (selectedOptions) this.restoreSelectedOptions(selectedOptions);

          const matched = this.findExactVariant(this.getSelectedOptions());
          this.currentVariant = matched || null;
          if (matched) this.dataset.selectedVariantId = String(matched.id);
          this.updateOptionAvailability();
          this.updateTotalPrice();
          this.syncSelectedVariantState();
          if (matched) {
            this.updateVariantUrl(productUrl, matched.id);
            if (matched.featuredMediaId)
              this.updateMedia(matched.featuredMediaId);
          }
          if (input?.id)
            document.getElementById(input.id)?.focus({ preventScroll: true });
        })
        .catch((error) => {
          if (error.name !== "AbortError") console.error(error);
        });
    }

    updateVariantUrl(productUrl, variantId) {
      if (!productUrl || !variantId) return;
      const nextUrl = `${productUrl}?variant=${variantId}`;
      window.history.replaceState({}, "", nextUrl);
    }

    selectVariant(variant, { updateUrl = true, updateMedia = true } = {}) {
      if (!variant) return;

      this.currentVariant = variant;
      this.dataset.selectedVariantId = String(variant.id);
      this.syncOptionInputs(variant);
      this.updateOptionAvailability();
      this.updateTotalPrice();
      this.syncSelectedVariantState();

      if (updateUrl) this.updateVariantUrl(this.dataset.url, variant.id);

      if (updateMedia && variant.featuredMediaId) {
        this.updateMedia(variant.featuredMediaId);
      }
    }

    syncOptionInputs(variant) {
      this.optionGroups.forEach((group, index) => {
        const value = this.getVariantOptionValue(variant, index);
        if (!value) return;
        group.querySelectorAll("input").forEach((input) => {
          input.checked = String(input.value) === value;
        });
      });
    }

    updateSelectedLabels() {
      this.optionGroups.forEach((group) => {
        const checked = group.querySelector("input:checked");
        const label = group.querySelector("[data-selected-value]");
        if (!checked || !label) return;
        label.textContent = checked.value;
      });
    }

    matchesOtherSelectedOptions(variant, groupIndex) {
      return this.optionGroups.every((group, index) => {
        if (index >= groupIndex) return true;
        const checked = group.querySelector("input:checked");
        if (!checked) return true;
        return (
          this.getVariantOptionValue(variant, index) === String(checked.value)
        );
      });
    }

    updateOptionAvailability() {
      this.optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll("input").forEach((input) => {
          const exists = this.variants.some(
            (variant) =>
              this.getVariantOptionValue(variant, groupIndex) ===
                String(input.value) &&
              this.matchesOtherSelectedOptions(variant, groupIndex),
          );
          const sellable = this.variants.some(
            (variant) =>
              this.getVariantOptionValue(variant, groupIndex) ===
                String(input.value) &&
              this.matchesOtherSelectedOptions(variant, groupIndex) &&
              this.isVariantSellable(variant),
          );
          const soldOut = exists && !sellable;
          input.classList.toggle("is-unavailable", !exists);
          input.classList.toggle("is-sold-out", soldOut);
        });
      });
      this.updateSelectedLabels();
    }

    updateMedia(mediaId) {
      const imageBtn = document.querySelector(
        '.media-options-container button[data-type="image"]',
      );
      if (imageBtn && !imageBtn.classList.contains("active")) imageBtn.click();

      const thumb = document.querySelector(
        `.product__thumbnail-item[data-media-id="${mediaId}"]`,
      );
      const gallery = document.querySelector("product-media-images");
      if (thumb && gallery && typeof gallery.select === "function") {
        gallery.select(parseInt(thumb.dataset.idx, 10));
      }
    }

    applyPolicyState(policyState) {
      if (!policyState) return;

      const policyTitle = this.sectionRoot.querySelector(
        "[data-stock-policy-title]",
      );
      const policyDescription = this.sectionRoot.querySelector(
        "[data-stock-policy-description]",
      );
      if (!policyTitle || !policyDescription) return;

      const template = this.sectionRoot.querySelector(
        `[data-policy-template="${policyState}"]`,
      );
      if (!template) return;

      const templateTitle = template.content.querySelector(
        "[data-policy-title]",
      );
      const templateDescription = template.content.querySelector(
        "[data-policy-description]",
      );

      if (templateTitle) {
        policyTitle.innerHTML = templateTitle.innerHTML.trim();
      }

      if (templateDescription) {
        const descriptionHtml = templateDescription.innerHTML.trim();
        policyDescription.innerHTML = descriptionHtml;
        policyDescription.style.display = descriptionHtml ? "" : "none";
      }
    }

    isVariantSellable(variant) {
      if (!variant) return false;
      return variant.available === true || variant.canSell === true;
    }

    blockedButtonText() {
      const combinationMissing =
        !this.isTablePicker && this.optionGroups.length > 0 && !this.currentVariant;
      if (combinationMissing) {
        return window.variantStrings?.unavailable || "Unavailable";
      }
      return window.variantStrings?.soldOut || "Sold out";
    }

    syncSelectedVariantState() {
      const sellable = this.isVariantSellable(this.currentVariant);
      const addToCartText = window.variantStrings?.addToCart || "Add To Cart";
      const soldOutText = this.blockedButtonText();

      if (this.qtyInput) this.qtyInput.disabled = !sellable;
      if (this.minusBtn) this.minusBtn.disabled = !sellable;
      if (this.plusBtn) this.plusBtn.disabled = !sellable;

      if (this.addonLocked) {
        this.syncAddonButtonState(true);
      } else {
        if (this.externalButton) {
          this.externalButton.disabled = !sellable;
          if (sellable) {
            this.externalButton.removeAttribute("aria-disabled");
          } else {
            this.externalButton.setAttribute("aria-disabled", "true");
          }
          const span = this.externalButton.querySelector("span");
          if (span) span.textContent = sellable ? addToCartText : soldOutText;
        }
        if (this.checkoutButton) {
          this.checkoutButton.disabled = !sellable;
          if (sellable) {
            this.checkoutButton.removeAttribute("aria-disabled");
          } else {
            this.checkoutButton.setAttribute("aria-disabled", "true");
          }
        }
      }

      this.applyPolicyState(this.currentVariant?.policyState);
    }

    getSelectedItems() {
      if (this.isTablePicker) return this.getTableSelectedItems();

      if (!this.currentVariant || !this.isVariantSellable(this.currentVariant))
        return [];

      const qty = parseInt(this.qtyInput?.value, 10) || 0;
      if (qty <= 0) return [];

      const quantity = this.isCartAddonProduct() ? 1 : qty;
      return [{ id: parseInt(this.currentVariant.id, 10), quantity }];
    }

    bindPriceContainers() {
      const root =
        this.closest(".shopify-section") || this.sectionRoot || document;
      const containers = new Set([
        ...this.querySelectorAll("[data-product-total-price]"),
        ...root.querySelectorAll("[data-product-total-price]"),
      ]);
      const byId = document.getElementById(`ProductPrice-${this.sectionId}`);
      if (byId) containers.add(byId);
      this.priceContainers = [...containers];
      this.priceContainer = this.priceContainers[0] || null;
      this.priceContainers.forEach((container) => {
        const saveLabel = container.querySelector(".save-label");
        if (!saveLabel) return;
        const extracted = saveLabel.innerText
          .replace(/[0-9.,$€£¥]/g, "")
          .trim();
        if (extracted) this.saveText = extracted;
      });
      return this.priceContainers.length > 0;
    }

    formatVariantMoney(cents) {
      if (typeof window.formatMoneyAmount === "function") {
        return window.formatMoneyAmount(cents);
      }
      const amount = (Number(cents) / 100).toFixed(2);
      return `$${amount}`;
    }

    updateTotalPrice() {
      if (!this.bindPriceContainers()) return;

      let totalPrice = 0;
      let totalComparePrice = 0;

      if (this.isTablePicker) {
        let selectedQty = 0;
        this.rows.forEach((row) => {
          const input = row.querySelector(".qty-input");
          const qty = parseInt(input?.value, 10) || 0;
          selectedQty += qty;
          const price = parseFloat(row.dataset.price) || 0;
          const comparePrice = parseFloat(row.dataset.comparePrice) || price;
          totalPrice += price * qty;
          totalComparePrice += comparePrice * qty;
        });

        if (selectedQty === 0 && this.rows.length) {
          const selectedId = String(this.dataset.selectedVariantId || "");
          const row =
            Array.from(this.rows).find(
              (item) => String(item.dataset.variantId) === selectedId,
            ) || this.rows[0];
          totalPrice = parseFloat(row.dataset.price) || 0;
          totalComparePrice = parseFloat(row.dataset.comparePrice) || totalPrice;
        }
      } else if (this.currentVariant) {
        const parsedQty = parseInt(this.qtyInput?.value, 10);
        const qty =
          parsedQty > 0 ? parsedQty : parseInt(this.dataset.minQty, 10) || 1;
        const variantPrice = Number(this.currentVariant.price) || 0;
        const variantCompare =
          Number(this.currentVariant.comparePrice) || variantPrice;
        totalPrice = variantPrice * qty;
        totalComparePrice = variantCompare * qty;
      } else {
        return;
      }

      let html = "";

      if (totalComparePrice > totalPrice) {
        html += `<span class="price fz-28 fz-m-24 fw-600 fw-m-500">${this.formatVariantMoney(totalPrice)}</span>`;
        html += `<s class="compare-price fz-16 fz-m-14">${this.formatVariantMoney(totalComparePrice)}</s>`;
        html += `<span class="py-8 px-12 py-m-4 px-m-8 fz-14 fz-m-12 save-label fw-500">${this.saveText} ${this.formatVariantMoney(totalComparePrice - totalPrice)}</span>`;
      } else {
        html += `<span class="price fz-28 fz-m-24 fw-600">${this.formatVariantMoney(totalPrice)}</span>`;
      }

      this.priceContainers.forEach((container) => {
        container.innerHTML = html;
      });
    }

    updateQuantity(change) {
      if (!this.qtyInput) return;

      const minQty = parseInt(this.dataset.minQty, 10) || 1;
      let val = parseInt(this.qtyInput.value, 10) || 0;
      val = change === 0 ? val : val + change;

      if (isNaN(val) || val < minQty) val = minQty;
      if (this.isCartAddonProduct() && val > 1) val = 1;

      this.qtyInput.value = val;
      this.updateTotalPrice();
    }
    handleErrorMessage(errorMessage = false) {
      if (!this.errorMessageWrapper) return;
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".variants-form__error-message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    async addToCart(e) {
      if (e) e.preventDefault();
      if (this.addonLocked) return;
      if (!this.isTablePicker && !this.isVariantSellable(this.currentVariant)) {
        this.syncSelectedVariantState();
        this.handleErrorMessage(this.blockedButtonText());
        return;
      }
      if (this.externalButton && this.externalButton.disabled) return;

      if (this.isCartAddonProduct()) {
        try {
          const cart = await fetch(
            (window.Shopify?.routes?.root || "/") + "cart.js",
          ).then((response) => response.json());
          if (this.addonItemInCartData(cart)) {
            this.syncAddonButtonState(true);
            return;
          }
        } catch (error) {
          // If cart lookup fails, continue with the guarded add below.
        }
      }

      this.handleErrorMessage();

      this.syncPickerState();
      const items = this.getSelectedItems();

      if (items.length === 0) {
        this.handleErrorMessage("Please select at least one item.");
        return;
      }

      if (!this.cartDrawer)
        this.cartDrawer = document.querySelector("cart-drawer");

      let originalText = "";
      let btnTextSpan = null;

      if (this.externalButton) {
        this.externalButton.classList.add("loading");
        this.externalButton.disabled = true;
        this.externalButton.setAttribute("aria-disabled", true);

        btnTextSpan = this.externalButton.querySelector("span");
        if (btnTextSpan) {
          originalText = btnTextSpan.innerText;
          btnTextSpan.innerText = "Adding...";
        } else {
          originalText = this.externalButton.innerText;
          this.externalButton.innerText = "Adding...";
        }
      }

      let sectionsToRender = [];
      if (this.cartDrawer) {
        sectionsToRender = this.cartDrawer
          .getSectionsToRender()
          .map((section) => section.id);
      }
      const bubble = document.getElementById("cart-icon-bubble");
      if (bubble) sectionsToRender.push("cart-icon-bubble");

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          items: items,
          sections: sectionsToRender,
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            let message = data.description || data.message;

            // 注意：如果这里仍然返回 already sold out，说明 Shopify 后端没有允许这个变体售卖。
            // 前端 JS 不能绕过 Shopify 后端库存校验，需要检查该 variant 的 Continue selling 设置、销售渠道/市场/库存地点。
            this.handleErrorMessage(message);
            if (this.cartDrawer) this.cartDrawer.reload();
          } else {
            if (this.cartDrawer) this.cartDrawer.renderContents(data);

            if (data.sections && data.sections["cart-icon-bubble"]) {
              const bubble = document.getElementById("cart-icon-bubble");
              if (bubble) bubble.innerHTML = data.sections["cart-icon-bubble"];
            }

            if (this.isCartAddonProduct()) {
              this.syncAddonButtonState(true);
            }
          }
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage("Something went wrong. Please try again.");
        })
        .finally(() => {
          if (
            this.cartDrawer &&
            this.cartDrawer.classList.contains("is-empty")
          ) {
            this.cartDrawer.classList.remove("is-empty");
          }

          if (this.addonLocked) {
            this.syncAddonButtonState(true);
          } else if (this.externalButton) {
            this.externalButton.classList.remove("loading");
            this.externalButton.disabled = false;
            this.externalButton.removeAttribute("aria-disabled");

            if (btnTextSpan) {
              btnTextSpan.innerText = originalText;
            } else {
              this.externalButton.innerText = originalText;
            }
          }

          if (!this.addonLocked) this.syncPickerState();
        });
    }

    async handleCheckout(e) {
      if (e) e.preventDefault();

      if (this.addonLocked) return;
      if (!this.isTablePicker && !this.isVariantSellable(this.currentVariant)) {
        this.syncSelectedVariantState();
        this.handleErrorMessage(this.blockedButtonText());
        return;
      }
      if (this.checkoutButton && this.checkoutButton.disabled) return;

      if (this.isCartAddonProduct()) {
        try {
          const cart = await fetch(
            (window.Shopify?.routes?.root || "/") + "cart.js",
          ).then((response) => response.json());
          if (this.addonItemInCartData(cart)) {
            this.syncAddonButtonState(true);
            return;
          }
        } catch (error) {
          // If cart lookup fails, continue with the guarded checkout below.
        }
      }

      this.handleErrorMessage();

      this.syncPickerState();
      const queryParts = this.getSelectedItems().map(
        (item) => `${item.id}:${item.quantity}`,
      );

      if (queryParts.length === 0) {
        this.handleErrorMessage("Please select at least one item.");
        return;
      }

      if (this.checkoutButton) {
        this.checkoutButton.classList.add("loading");
        this.checkoutButton.disabled = true;
        const btnSpan = this.checkoutButton.querySelector("span");
        if (btnSpan) btnSpan.innerText = "Adding...";
        else this.checkoutButton.innerText = "Adding...";
      }

      const cartUrl =
        window.Shopify.routes.root + "cart/" + queryParts.join(",");

      window.location.href = cartUrl;
    }
  }

  if (!customElements.get("variant-select")) {
    customElements.define("variant-select", VariantSelect);
  } else {
    const registered = customElements.get("variant-select");
    Object.getOwnPropertyNames(VariantSelect.prototype).forEach((name) => {
      if (name === "constructor") return;
      Object.defineProperty(
        registered.prototype,
        name,
        Object.getOwnPropertyDescriptor(VariantSelect.prototype, name),
      );
    });
    document.querySelectorAll("variant-select").forEach((el) => {
      el.bindPriceContainers =
        VariantSelect.prototype.bindPriceContainers.bind(el);
      el.formatVariantMoney =
        VariantSelect.prototype.formatVariantMoney.bind(el);
      el.updateTotalPrice = VariantSelect.prototype.updateTotalPrice.bind(el);
      el.onOptionChange = VariantSelect.prototype.onOptionChange.bind(el);
      el.selectVariant = VariantSelect.prototype.selectVariant.bind(el);
      el.updateTotalPrice();
    });
  }

  const ProductRecommendation = class extends HTMLElement {
    async connectedCallback() {
      if (!this.hasAttribute("use-automatic-recommendations")) {
        return;
      }
      try {
        const response = await fetch(
          `${this.recommendationsUrl}?product_id=${this.productId}&limit=${this.recommendationsCount}&section_id=${this.sectionId}`,
        );
        if (!response.ok) return;

        const div = document.createElement("div");
        div.innerHTML = await response.text();
        const productRecommendationsElement = div.querySelector(
          "product-recommendation",
        );
        if (productRecommendationsElement?.hasChildNodes()) {
          this.innerHTML = productRecommendationsElement.innerHTML;
        }
      } catch (error) {
        console.error(error);
      }
    }
    get recommendationsUrl() {
      return this.getAttribute("data-product-recommendations-url");
    }
    get productId() {
      return this.getAttribute("product-id");
    }
    get sectionId() {
      return this.getAttribute("section-id");
    }
    get recommendationsCount() {
      return parseInt(this.getAttribute("recommendations-count") || 4);
    }
  };
  window.customElements.define("product-recommendation", ProductRecommendation);

  class QuotoBtn extends HTMLButtonElement {
    connectedCallback() {
      this.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        // 核心逻辑：找到弹窗并显示
        const popup = document.querySelector(".get_a_quote_popup");
        if (popup) {
          popup.classList.add("active");
        }
      });
    }
  }

  // 注册组件，继承自 button
  if (!customElements.get("quoto-btn")) {
    customElements.define("quoto-btn", QuotoBtn, { extends: "button" });
  }

  class CustomDetails extends HTMLElement {
    constructor() {
      super();
      this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }

    connectedCallback() {
      // 获取内部的 details 元素
      this.details = this.querySelector("details");
      // 监听全局点击
      document.addEventListener("click", this.handleOutsideClick);
    }

    disconnectedCallback() {
      // 卸载组件时移除监听
      document.removeEventListener("click", this.handleOutsideClick);
    }

    handleOutsideClick(event) {
      // 1. 如果 details 没打开，不需要处理
      if (!this.details.hasAttribute("open")) return;

      // 2. 检查点击的元素是否在当前组件 custom-details 内部
      // event.target 是触发点击的元素，this 是 custom-details
      const isClickInside = this.contains(event.target);
      if (!isClickInside) {
        // 3. 如果点击在外部，关闭 details
        this.details.removeAttribute("open");
      }
    }
  }

  // 注册自定义组件
  if (!customElements.get("custom-details")) {
    customElements.define("custom-details", CustomDetails);
  }
})();
